define('common/triple',["require", "exports"], function (require, exports) {
    "use strict";
    var Triple = (function () {
        function Triple(item1, item2, item3) {
            this.item1 = item1;
            this.item2 = item2;
            this.item3 = item3;
        }
        return Triple;
    }());
    return Triple;
});

